import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import ContentWrapper from '../../Wrappers/ContentWrapper';
import FilesDragAndDrop from '../../Shared/FilesDragAndDrop';
import { useSelector } from 'react-redux';
import { getTransitionWithVariable } from '../../../redux_store/reducer/reducers/i18nReducer';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  link: {
    fontSize: 16,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
}));

const InsuranceUpload = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const classes = useStyles();
  const { title } = useParams();
  const steps = [titles.selectAndUploadFile, getTransitionWithVariable(titles.itemSuccessfullyImported, {
    item: titles.insurance,
  })];

  return (
    <ContentWrapper
      titleText={getTransitionWithVariable(titles.insuranceUploadForAccount, {
        accountName: title,
      })}
      className={classes.paper}
    >
      <FilesDragAndDrop
        hasValidation={false}
        name={'insurance'}
        steps={steps}
      />
    </ContentWrapper>
  );
};

export default InsuranceUpload;
